/**
 * To call: store.dispatch('addExample', '')
 */
const showSnack = ({ commit }, snack) => {
  const aux = {
    text: '',
    action: () => {},
    timeout: 8000,
  }
  commit('SHOW_SNACKBAR', { ...aux, ...snack })
}

const closeSnack = ({ commit }) => {
  commit('CLOSE_SNACKBAR')
}

const showModal = ({ commit }, modal) => {
  const aux = {
    type: '',
    text: '',
    html: '',
    title: 'Aviso',
    v2: false,
    buttons: [],
    closable: true,
    persistent: false,
    'max-width': '500px',
  }
  commit('SHOW_MODAL', { ...aux, ...modal })
}

const closeModal = ({ commit }) => {
  commit('CLOSE_MODAL')
}

const addQueueSnackModal = ({ commit }, payload) => {
  commit('ADD_QUEUE_SNACK_MODAL', payload)
}

const removeFirstSnackModal = ({ commit }, payload) => {
  commit('REMOVE_FIRST_SNACK_MODAL', payload)
}

export {
  showSnack,
  closeSnack,
  showModal,
  closeModal,
  addQueueSnackModal,
  removeFirstSnackModal,
}
